<template>
  <div class="productNotAvailable">
    <breadcrumbs :list="breadcrumbs" v-if="breadcrumbs && breadcrumbs.length" />
    <div class="productNotAvailable__inner">
      <div class="productNotAvailable__products">
        <div class="productNotAvailable__productsContent">
          <div class="productNotAvailable__header">
            <div class="productNotAvailable__headerTitle">
              {{ title }}
            </div>
            <div class="productNotAvailable__headerImage">
              <img alt="" src="/images/productNotAvailable.svg" />
            </div>
          </div>
          <div class="productNotAvailable__title">Zobacz podobne produkty:</div>
        </div>
        <slider-tiles
          v-if="products && products.length"
          :items="products"
          :breakpoints="{
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }"
          :slides-per-view="1"
          nav-buttons-type="rounded"
        />
      </div>
      <div class="productNotAvailable__categories" v-if="categories && categories.length">
        <ul class="productNotAvailable__categoriesList">
          <li :key="category.id" v-for="category in categories">
            <nuxt-link
              :to="localePath({ name: 'category-slug', params: { slug: category.slug } })"
              >{{ category.name }}</nuxt-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '~/components/Breadcrumbs';
import SliderTiles from '@/components/Sliders/SliderTiles.vue';

export default {
  name: 'ProductNotAvailable',
  components: {
    SliderTiles,
    Breadcrumbs,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.productNotAvailable {
  &__inner {
    max-width: 1078px;
    margin: 2rem auto 0;
  }

  &__products {
    margin-bottom: 1.6rem;
    background: $cWhite;
  }

  &__productsContent {
    padding: 0 4.5rem 2rem;

    @include rwd('tablet') {
      padding: 0 2.5rem 2rem;
    }
  }

  &__header {
    display: flex;
  }

  &__headerImage {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__headerTitle {
    margin-bottom: 1rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;
    padding-top: 4rem;

    @include rwd('tablet') {
      font-size: 2.6rem;
      line-height: 3.5rem;
      margin-bottom: 2rem;
      padding-top: 3rem;
    }
  }

  &__title {
    font-size: 2rem;
    line-height: 2.5rem;
    font-weight: 600;
  }

  &__categories {
    background: $cWhite;
    padding: 4rem;

    @include rwd('tablet') {
      padding: 3rem 2.5rem;
    }
  }

  &__categoriesList {
    column-count: 3;
    column-gap: 50px;

    @include rwd('tablet') {
      column-count: 2;
    }

    @include rwd('large-phone') {
      column-count: 1;
    }

    a {
      font-size: 1.6rem;
      line-height: 3rem;
      transition: color $tr;

      &:hover {
        color: $cSec;
      }
    }
  }
}
</style>
